import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { tp } from 'app/utils/typograf';
import cookiesIcon from './img/cookies.png';


import css from './CookiesNotification.module.scss';

const isSeenSaved = localStorage.getItem('cookies-rules-accepted') === 'true';


const saveSeenState = () => {
    localStorage.setItem('cookies-rules-accepted', 'true');
};


// NY26
interface INotificationProps {
    isScalable?: boolean,
    pageClass?: string
}
export const CookiesNotification: FC = ({
    isScalable = false,
    pageClass = '',
}: INotificationProps) => {
    const [hasSeen, setHasSeen] = useState<boolean>(isSeenSaved);

    const currentPageClass: any = window.location?.pathname.includes('/5x2b') ? 'custom' : pageClass;

    const rootClasses = classNames({
        [css.cookiesNotificationRoot]: true,
        [css.scalable]: isScalable,
        [css[currentPageClass]]: Boolean(currentPageClass),
    });

    const wrapperClasses = classNames({
        [css.cookiesNotificationRootWrapper]: true,
        [css[currentPageClass]]: Boolean(currentPageClass),
    });

    const buttonClasses = classNames({
        [css.cookiesNotificationAcceptButton]: true,
        [css[currentPageClass]]: Boolean(currentPageClass),
    });

    const toggleNotification = () => {
        setHasSeen((prev) => {
            const event = new CustomEvent('getNotificationRenderState', {
                detail: { renderState: !prev },
            });
            document.dispatchEvent(event);
            return !prev;
        });
    };

    if (hasSeen) {
        return null;
    }

    return (
        <div className={wrapperClasses}>
            <div className={rootClasses}>
                <div className={css.cookiesNotificationIconWrapper}>
                    <img
                        className={css.cookiesNotificationIcon}
                        src={cookiesIcon}
                        alt="accept the cookies policy"
                    />
                </div>
                <div className={css.cookiesNotificationText}>
                    {' '}
                    <span>
                        Принять
                    </span>
                    {' '}
                    <a
                        href="/cookie_policy/"
                        className={css.underlined}
                    >
                        политику использования cookie
                    </a>
                    <br className={css.cookiesNotificationTextMobile} />
                    {' '}
                    и
                    {' '}
                    {currentPageClass === 'basketButton'
                        ? (
                            <a
                                href="/personal_data_policy/"
                            >
                                <span className={`${css.trialXS} ${css.underlined}`}>{tp.execute(' обработки персональных данных')}</span>
                                <span className={`${css.trialM} ${css.underlined}`}>{tp.execute(' обработки персональных данных')}</span>
                                <span className={`${css.trialS} ${css.underlined}`}>{tp.execute(' обработки перс. данных')}</span>
                            </a>
                        ) : (
                            <a
                                href="/personal_data_policy/"
                                className={css.underlined}
                            >
                                <span>{tp.execute(' обработки персональных данных')}</span>
                            </a>
                        )}
                </div>
                <div
                    className={css.cookiesNotificationAcceptButtonWrapper}
                    onClick={() => {
                        toggleNotification();
                        saveSeenState();
                    }}
                    role="none"
                >
                    <button
                        className={buttonClasses}
                        type="button"
                    >
                        ОК
                    </button>
                </div>
            </div>
        </div>
    );
};
